import React from "react";
import TaskBarComponent from "./TaskBarComponent";
import YoutubeEmbed from "./Youtube-embed";

export default function About() {
    return (
        <div className="About">
            <TaskBarComponent />
            <div>
                <h1>About Decisions Manager</h1>
                <p>Decisions Manager is a tool designed to streamline note taking for team discussions in professional setting. 
                    It is designed to be used in a meeting where a user(typically a program/project manager) can create a meeting and add agenda items to the meeting.
                    The user can then take notes of the talking points of individuals and decisions made during the meeting.
                    The application stores the opinions and decisions made during the meeting in a database. These items can be searched through using free text. 
                </p>
                <h2>Key Features of MVP</h2>
                <ul>
                    <li>Meeting Creation with Agenda Items</li>
                    <li>Capture Meeting Notes per participant</li>
                    <li>Capture Decisions</li>
                    <li>Search Meeting Notes</li>
                </ul>
                <h2>TBD: Milestone 1</h2>
                <ul>
                    <li>One click meeting notes page creation with text boxes for individuals invited in a calender meeting invite with agenda items</li>
                    <li>One click meetng notes share with mailing list</li>
                    <li>Predictive Text for faster note taking</li>
                    <li>Capture Action Items</li>
                </ul>
                <div>
                    <h2>Decisions Manager MVP Demo</h2>
                    <YoutubeEmbed embedId="WTvuaT0xZG8" />
                </div>
                <h2>Contact Us</h2>
                <p>savanrpatel@outlook.com</p> 
            </div>
        </div>
    );
}
